var exports = {
  "sectorWithSticky": "x620889e6--7d8541--sectorWithSticky",
};

module.exports = exports;
